import gql from 'graphql-tag';

const LOG_MODULE_ACCESS = gql`
    mutation logModuleAccess ($input: ModuleAccessLogInput) {
        logModuleAccess (input: $input) {
            status
            message
        }
    }
`;

export default LOG_MODULE_ACCESS;
